import httpRequest from '@/utils/request';

export const createReminderUrl = (moduleType: 'Issue', mId: string) => {
  return `/${moduleType}/${mId}/reminds`;
};
export const addReminds = (url: string, reminderIds: string[]): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(url, reminderIds);
};
export const delReminds = (url: string, reminderIds: string[]): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(url, {
    data: reminderIds,
  });
};

export const requestAddReminders = (
  url: string,
  reminderIds: string[],
): Promise<string> => {
  return new Promise((reslove, reject) => {
    addReminds(url, reminderIds)
      .then((res) => {
        reslove(res.message);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
};
export const requestDeleteReminders = (
  url: string,
  reminderIds: string[],
): Promise<string> => {
  return new Promise((reslove, reject) => {
    delReminds(url, reminderIds)
      .then((res) => {
        reslove(res.message);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
};
